import React from 'react';
import { Navigate } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ImplementationWizard } from '~/core/routes/settings/implementations/create/ImplementationWizard';

export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/implementations" />;
    }}
  >
    <ImplementationWizard />
  </RouteErrorBoundary>
);
